module.exports = __webpack_public_path__ + "img/1723011608937-WhatsApp Image 2024-08-07 at 12.02.14 1.jpeg.50cd354d.webp";